import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from './store';

Vue.config.productionTip = false;
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import i18n from './i18n';
import enLocale from './locales/en.json';
import arLocale from './locales/ar.json';
import frLocale from './locales/fr.json';
import itLocale from './locales/it.json';
import deLocale from './locales/de.json';
import ruLocale from './locales/ru.json';

const localLocales = {
  en: enLocale,
  ar: arLocale,
  fr: frLocale,
  it: itLocale,
  de: deLocale,
  ru: ruLocale,
};

// import user class
import User from './Helpers/User';
window.User = User;
Vue.use(VueAxios, axios);

// Intercept frontend-keywords to guarantee genuine French and Italian keywords (overriding Dutch/Polish)
// and ensure new keys (such as saveAsPdf) exist for all languages
axios.interceptors.response.use(
  (response) => {
    if (
      response.config &&
      response.config.url &&
      response.config.url.indexOf('frontend-keywords') !== -1
    ) {
      const url = response.config.url;
      const isFr =
        url.indexOf('lang=fr') !== -1 ||
        (response.data && response.data.home && response.data.home.bookNow === 'Boek Nu');
      const isIt =
        url.indexOf('lang=it') !== -1 ||
        (response.data && response.data.home && response.data.home.bookNow === 'Zarezerwuj teraz');

      if (isFr) {
        response.data = { ...response.data, ...frLocale };
      } else if (isIt) {
        response.data = { ...response.data, ...itLocale };
      } else {
        const langMatch = url.match(/[?&]lang=([a-zA-Z_-]+)/);
        const langCode = langMatch ? langMatch[1] : (localStorage.getItem('localization') || 'en');
        const fallback = localLocales[langCode] || enLocale;
        if (response.data && typeof response.data === 'object') {
          response.data.qrPrint = {
            ...(fallback.qrPrint || {}),
            ...(response.data.qrPrint || {}),
          };
        }
      }
    }
    return response;
  },
  (error) => Promise.reject(error)
);

// import preloader
import loader from 'vue-ui-preloader';
// import notifications
import Notifications from 'vue-notification';
// import notification class
import Notifcation from './Helpers/Notification';
window.Notification = Notifcation;
/*	  detectBrowserLanguage() {
      // Get the browser's preferred language
        const primaryLanguage = navigator.language.substr(0, 2).toLowerCase();
  
  // Map the primary language code to the specified languages
  switch (primaryLanguage) {
    case 'ar':
      this.browserLanguage = 'ar'; // Arabic
      break;
    case 'en':
      this.browserLanguage = 'en'; // English
      break;
    case 'it':
      this.browserLanguage = 'it'; // Italian
      break;
    case 'de':
      this.browserLanguage = 'de'; // German
      break;
    case 'fr':
      this.browserLanguage = 'fr'; // French
      break;
    default:
      // Default to English if the browser language is not one of the specified languages
      this.browserLanguage = 'en'; // English
	   this.$i18n.locale = this.browserLanguage;
      localStorage.setItem('localization', locale);
      
  }
*/
Vue.use(Notifications);
Vue.use(loader);
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
 //   router.push('/en');
  }
  next();
});

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
